<script setup lang="ts">
import type { Product } from '~/models/Product'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { KsButton, KsDialog } from '@aschehoug/kloss'
import useAuthStore from '~/stores/auth'
import { TeleportationTarget } from '~/models/TeleportationTarget'

const props = defineProps<{
  open: boolean
  product: Product | undefined
}>()

const { t } = useI18n()
const { isTeacher } = storeToRefs(useAuthStore())

const webshopUrl = computed(() => props.product?.aunivers.webshopUrl
  ? props.product?.aunivers.webshopUrl
  : import.meta.env.VITE_WEBSHOP_TRIALURL)

const description = computed(() => props.product
  ? t('search.lockedContent.relatedProduct', { product: props.product.name })
  : t('search.lockedContent.unknownProduct'))

const emit = defineEmits(['closeDialog'])
</script>

<template>
  <Teleport :to="TeleportationTarget.AppTop">
    <KsDialog
      :open="open"
      :title="t('search.lockedContent.noAccess')"
      @close="emit('closeDialog')"
    >
      <template #body>
        <p
          class="mb-1"
          v-html="description"
        />
        <p v-text="isTeacher ? t('search.lockedContent.findTeacher') : t('search.lockedContent.findStudent')" />
      </template>
      <template #footer>
        <div class="flex justify-end gap-3">
          <KsButton
            shape="rounded"
            :variant="isTeacher ? 'tertiary' : 'primary'"
            @click="emit('closeDialog')"
          >
            {{ t('close') }}
          </KsButton>
          <KsButton
            v-if="isTeacher"
            shape="rounded"
            variant="primary"
            icon-right="arrow-up-right-from-square"
            :href="webshopUrl"
            target="_blank"
            @click="emit('closeDialog')"
          >
            {{ t('search.lockedContent.goToWebshop') }}
          </KsButton>
        </div>
      </template>
    </KsDialog>
  </Teleport>
</template>
